/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Empty_All_HintInputs */

const cs_documents_empty_all_hint = /** @type {(inputs: Documents_Empty_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořte složku pro dokumenty, které nepatří k nemovitosti, klientovi ani obchodu.`)
};

const en_documents_empty_all_hint = /** @type {(inputs: Documents_Empty_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a folder for documents that don't belong to a property, client or deal.`)
};

/**
* | output |
* | --- |
* | "Create a folder for documents that don't belong to a property, client or deal." |
*
* @param {Documents_Empty_All_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_empty_all_hint = /** @type {((inputs?: Documents_Empty_All_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Empty_All_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_empty_all_hint(inputs)
	return cs_documents_empty_all_hint(inputs)
});